exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "* {\n  margin: 0;\n  padding: 0;\n  font-family: PingFang-SC-Regular;\n}\nbody {\n  background: #F7F7F7;\n}\nli {\n  list-style: none;\n}\n.icon-ali-pay {\n  color: #33AEE6;\n}\n.icon-wx-pay {\n  color: #24A757;\n}\n.icon-radio-on {\n  color: #F97E44;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/index.less
// module id = 39
// module chunks = 0